import React, { useEffect } from "react";
import logoImg from "../../assets/images/marriott-logo.png";
import styles from "./ConsentThankYou.module.css";
import classNames from "classnames";
import { useLayoutStore } from "../../store";
import { useSearchParams } from "react-router-dom";
import { useConsent } from "../../hooks/useConsent";
import { useAcid } from "../../hooks/useAcid";

export const ConsentThankYou = () => {
  const { setShowFooter, setShowHeader } = useLayoutStore();
  const [searchParams] = useSearchParams();
  const { acid } = useAcid();
  const { save, loading } = useConsent();

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 580;
      queueMicrotask(() => {
        setShowFooter(!isMobile);
        setShowHeader(!isMobile);
      });
    };

    // Set initial state
    handleResize();

    // Add resize listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className={styles.container}>
      <div className={styles.heroSection}>
        <img
          src="https://cache.marriott.com/is/image/marriotts7prod/rz-snarz-balcony-ocean-views-19031?wid=900"
          alt="Marriott Balcony Ocean View"
        />
      </div>

      <main className={styles.main}>
        <img className={styles.logo} src={logoImg} alt="Marriott logo" />
        <div className={styles.checkmark}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
          >
            <path
              d="M0.5 14C0.5 6.26801 6.76801 0 14.5 0C22.232 0 28.5 6.26801 28.5 14C28.5 21.732 22.232 28 14.5 28C6.76801 28 0.5 21.732 0.5 14Z"
              fill="#17B26A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.4458 8.62193L12.0925 16.6836L9.87583 14.3153C9.4675 13.9303 8.82583 13.9069 8.35916 14.2336C7.90416 14.5719 7.77583 15.1669 8.05583 15.6453L10.6808 19.9153C10.9375 20.3119 11.3808 20.5569 11.8825 20.5569C12.3608 20.5569 12.8158 20.3119 13.0725 19.9153C13.4925 19.3669 21.5075 9.81193 21.5075 9.81193C22.5575 8.7386 21.2858 7.7936 20.4458 8.61027V8.62193Z"
              fill="white"
            />
          </svg>
        </div>
        <h2 className={styles.mainTitle}>
          Thank you! Your preferences have been saved.
        </h2>
        <p className={styles.mainText}>
          You can always change your mind and update your preferences in your{" "}
          <a
            href="https://app.marriott.com/comm-preferences"
            target="_blank"
            rel="noopener noreferrer"
          >
            account settings
          </a>{" "}
          at any time.
        </p>
        {/* <div className={styles.buttonArea}>
          <button
            className={classNames(styles.primaryButton, "custom_click_track")}
            data-custom_click_track_value={`Consent Thank You|'Continue' button|external`}
            onClick={() =>
              (window.location.href =
                "https://app.marriott.com/comm-preferences")
            }
            disabled={loading}
            type="button"
          >
            {loading ? (
              <>
                <svg
                  className={styles.spinner}
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeOpacity="0.3"
                  />
                  <path
                    d="M12 2a10 10 0 0 1 10 10"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeLinecap="round"
                  />
                </svg>
                Saving...
              </>
            ) : (
              "Continue"
            )}
          </button>
        </div> */}
        <p className={styles.textFooter}>
          Thank you for being a valued Marriott guest. We’re committed to
          providing you with exceptional experiences while respecting your
          privacy preferences.
        </p>
      </main>
    </section>
  );
};
